const translations = {
    save: 'Save'
};

export default translations;
